// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.DeleteAccount_delete-account__b5ATH {
  min-height: 100vh;
  background-color: #eee;
  padding: 40px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
@media screen and (max-width: 600px) {
  .DeleteAccount_delete-account__b5ATH {
    min-height: calc(100vh - 46.8px);
    background-color: white;
    padding: 0;
  }
}
.DeleteAccount_delete-account__b5ATH form {
  padding: 40px;
  background-color: white;
  box-shadow: 0 0 20px #ccc;
  box-shadow: var(--shadow);
  border-radius: 5px;
  max-width: 600px;
  display: flex;
  flex-direction: column;
  align-items: center;
}
@media screen and (max-width: 600px) {
  .DeleteAccount_delete-account__b5ATH form {
    width: 100%;
    box-shadow: none;
    padding: 40px 20px;
    border-radius: 0;
  }
}
.DeleteAccount_delete-account__b5ATH form p {
  text-align: center;
}
.DeleteAccount_delete-account__b5ATH form .DeleteAccount_checkbox-container__0iSnq {
  display: flex;
  flex-direction: row;
  align-items: center;
  cursor: pointer;
}
.DeleteAccount_delete-account__b5ATH form .DeleteAccount_checkbox-container__0iSnq > * {
  margin: 0 10px;
}
.DeleteAccount_delete-account__b5ATH form .DeleteAccount_form-input__34COf {
  font-size: inherit;
}
.DeleteAccount_delete-account__b5ATH form .DeleteAccount_form-input__34COf:focus {
  box-shadow: 0 0 0 0.25rem hsla(0, 90%, 60%, 0.4);
  border-color: hsl(0, 88%, 50%);
}
.DeleteAccount_delete-account__b5ATH form button[type=submit] {
  background-color: red;
  color: white;
  /* existing styles */
  font-size: inherit;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
}
.DeleteAccount_delete-account__b5ATH form button[type=submit]:hover,
.DeleteAccount_delete-account__b5ATH form button[type=submit]:focus {
  background-color: hsl(0, 88%, 50%);
}
.DeleteAccount_delete-account__b5ATH form input,
.DeleteAccount_delete-account__b5ATH form button {
  margin: 7px 0;
  width: 100%;
}
.DeleteAccount_delete-account__b5ATH form .DeleteAccount_error__1CMbM {
  color: red;
}`, "",{"version":3,"sources":["webpack://./src/Pages/Settings/DeleteAccount/DeleteAccount.module.scss"],"names":[],"mappings":"AAAA;EACI,iBAAA;EACA,sBAAA;EACA,aAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;AACJ;AACI;EATJ;IAUQ,gCAAA;IACA,uBAAA;IACA,UAAA;EAEN;AACF;AACI;EACI,aAAA;EACA,uBAAA;EACA,yBAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;AACR;AACQ;EAXJ;IAYQ,WAAA;IACA,gBAAA;IACA,kBAAA;IACA,gBAAA;EAEV;AACF;AAAQ;EACI,kBAAA;AAEZ;AACQ;EACI,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,eAAA;AACZ;AACY;EACI,cAAA;AAChB;AAGQ;EACI,kBAAA;AADZ;AAGY;EACI,gDAAA;EACA,8BAAA;AADhB;AAKQ;EACI,qBAAA;EACA,YAAA;EAEA,oBAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,uBAAA;AAJZ;AAOQ;;EAEI,kCAAA;AALZ;AAQQ;;EAEI,aAAA;EACA,WAAA;AANZ;AASQ;EACI,UAAA;AAPZ","sourcesContent":[".delete-account {\n    min-height: 100vh;\n    background-color: #eee;\n    padding: 40px;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n\n    @media screen and (max-width: 600px) {\n        min-height: calc(100vh - 46.8px);\n        background-color: white;\n        padding: 0;\n\n    }\n\n    form {\n        padding: 40px;\n        background-color: white;\n        box-shadow: 0 0 20px #ccc;\n        box-shadow: var(--shadow);\n        border-radius: 5px;\n        max-width: 600px;\n        display: flex;\n        flex-direction: column;\n        align-items: center;\n\n        @media screen and (max-width: 600px) {\n            width: 100%;\n            box-shadow: none;\n            padding: 40px 20px;\n            border-radius: 0;\n        }\n\n        p {\n            text-align: center;\n        }\n\n        .checkbox-container {\n            display: flex;\n            flex-direction: row;\n            align-items: center;\n            cursor: pointer;\n\n            >* {\n                margin: 0 10px;\n            }\n        }\n\n        .form-input {\n            font-size: inherit;\n\n            &:focus {\n                box-shadow: 0 0 0 0.25rem hsla(0, 90%, 60%, 0.4);\n                border-color: hsl(0, 88%, 50%);\n            }\n        }\n\n        button[type=\"submit\"] {\n            background-color: red;\n            color: white;\n\n            /* existing styles */\n            font-size: inherit;\n            display: flex;\n            flex-direction: row;\n            align-items: center;\n            justify-content: center;\n        }\n\n        button[type=\"submit\"]:hover,\n        button[type=\"submit\"]:focus {\n            background-color: hsl(0, 88%, 50%);\n        }\n\n        input,\n        button {\n            margin: 7px 0;\n            width: 100%;\n        }\n\n        .error {\n            color: red;\n        }\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"delete-account": `DeleteAccount_delete-account__b5ATH`,
	"checkbox-container": `DeleteAccount_checkbox-container__0iSnq`,
	"form-input": `DeleteAccount_form-input__34COf`,
	"error": `DeleteAccount_error__1CMbM`
};
export default ___CSS_LOADER_EXPORT___;
